import {set} from 'lodash';
import theme from 'src/utils/theme';

export function setDebugger(key, value): void {
  if (process.env.NODE_ENV !== 'development') return;
  set(window, `debuggers.${key}`, value);
}

export function setDebuggingHelpers(): void {
  if (process.env.NODE_ENV !== 'development') return;
  setDebugger('theme', theme);
}
